<ag-grid-angular
  [gridOptions]="internalGridOptions"
  class="ag-theme-heitown flex-grow-1"
  [columnDefs]="columnDefs"
  [rowData]="items"
  [modules]="modules"
>
</ag-grid-angular>
